import { render } from "./view-album.vue?vue&type=template&id=1ebc51c0"
import script from "./view-album.vue?vue&type=script&lang=js"
export * from "./view-album.vue?vue&type=script&lang=js"

import "./view-album.vue?vue&type=style&index=0&id=1ebc51c0&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__